import Settings from '../settings';
import { handleMaintenanceResponse } from './maintenance';

const customHeader = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  //Authorization: localStorage.getItem('id_token') || undefined,
});

const request = (method, url, body = null, configHeader = null) => {
  var url_fetch = `${Settings.apiUrl}${url}`;
  var headers = customHeader();
  var id_token = localStorage.getItem('id_token');
  if (id_token) {
    headers['Authorization'] = id_token
  }
  var content = {
    method,
    headers: headers,
  }
  if (body) {
    content = {
      method,
      headers: headers,
      body: JSON.stringify(body),
    }
  }

  if(configHeader){
    content.headers = {
      'Authorization': id_token,
      ...configHeader};
    content.body =body;
  }
  return fetch(url_fetch, content)
    .then(res => {
      handleMaintenanceResponse(res);
      return res;
    })
    .catch(error => ({ error: error, error_msg: 'Error Fetching' }));
};

const SuperFetch = (method, url, body=null, configHeader = null) => {
  return request(method, url, body, configHeader);
}
export default SuperFetch;
